"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lenderSchema = exports.lenderAddressSchema = exports.claimPayeeSchema = exports.authorizedOfficerSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.authorizedOfficerSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    properties: {
        emailID: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        extensionPhoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 7,
            errorMessage: 'Should be a string with a maximum of 7 characters or null',
        },
        faxNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        firstName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        lastName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        phoneNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        positionTypeCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_2.AuthorizedOfficerPosition), [null]),
            errorMessage: 'Should equate to a valid AuthorizedOfficerPosition Enum value or null',
        },
    },
};
exports.claimPayeeSchema = {
    type: 'object',
    required: ['transitNumber', 'payeeID', 'name'],
    properties: {
        name: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        payeeID: {
            type: ['number', 'null'],
            // enum: TBD
            errorMessage: 'Should equate to a valid PayeeID Enum value or null',
        },
        transitNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        typeCode: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.ClaimPayeeType), [null]),
            errorMessage: 'Should equate to a valid ClaimPayeeType Enum value or null',
        },
    },
};
exports.lenderAddressSchema = {
    type: 'object',
    required: [],
    properties: {
        lineOneText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        lineTwoText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        municipalityName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        postalCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        provinceCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.StatisticsCanadaProvinceID), [null]),
            errorMessage: 'Should equate to a valid StatisticsCanadaProvinceID Enum value or null',
        },
    },
};
exports.lenderSchema = {
    type: 'object',
    required: [],
    properties: {
        address: exports.lenderAddressSchema,
        approvedLenderCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        authorizedOfficers: {
            type: ['array', 'null'],
            items: exports.authorizedOfficerSchema,
            errorMessage: 'Should be an array or null',
        },
        claimPayee: exports.claimPayeeSchema,
        correspondenceLanguageCode: {
            type: ['integer', 'null'],
            enum: __spreadArrays(Object.values(constants_1.Language), [null]),
            errorMessage: 'Should equate to a valid Language Enum value or null',
        },
    },
};
